import { useEffect, useState } from 'react';
import { accountRequest } from '../cdo/cdoAccount';
import { mediaSource } from '../shared/mediaSource';
import MediaImage from './MediaImage';

// Read each portrait in its own world, without selecting the game.
export default function CharacterCardPortrait({ characterId, name, available, request = accountRequest }) {
  const [src, setSrc] = useState('');
  useEffect(() => {
    let current = true;
    setSrc('');
    if (available) {
      const id = encodeURIComponent(characterId);
      request(`/worlds/${id}/being/select-portrait-image?idEntity=${id}`)
        .then(image => {
          if (current) setSrc(mediaSource(image, 'card'));
        })
        .catch(() => {}); // A missing portrait must not prevent opening the character.
    }
    return () => { current = false; };
  }, [characterId, available, request]);
  return <div className="alpha-character-portrait">
    {src ? <MediaImage src={src} alt={`Portrait of ${name}`} onError={() => setSrc('')} />
      : null}
  </div>;
}
